<template>
  <div class="main">
    <div class="loginBody">
      <div class="logo"></div>
      <div class="systemName">展場即時數據系統</div>
      <ul class="dateMenu">
        <li><a href="#" @click="btnExhActive()" v-bind:class="{active: isExhActive}" >我是廠商</a></li>
        <li><a href="#" @click="btnOrgActive()" v-bind:class="{active: isOrgActive}">我是主辦單位</a></li>
      </ul>
      <div class="loginBox">
        <div class="title_account">帳號</div>
        <div class="input_account">
          <input id="userAccount" v-model="email" type="text" placeholder="請輸入帳號" >
        </div>
        <div class="title_password">密碼</div>
        <div class="input_password">
          <input id="userPassword" v-model="password" type="password" placeholder="請輸入密碼">
        </div>
        <div class="loginActionBox">
          <a @click="loginUserVerify" href="#" class="button_red">登 入</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";

export default {
  name: "FirmLogin",
  components: {
    // Loading,
  },
  data: function () {
    return {
      SHOW_ID: "",
      EMAIL: "",
      PASSWORD: "",
      ROLE: "",
      BOOTH_ID: "",
      TOKEN: "",
      SID: "",
      START_DATE: "",
      END_DATE: "",
      SHOW_LOCAL_NAME: "",
      isExhActive: true,
      isOrgActive: false,
    };
  },
  created() {
    this.email = "";
    this.password = "";
    this.SHOW_ID = this.$route.params.showId;
    this.ROLE = "Exhibitors";
    this.isExhActive = true;
    this.isOrgActive = false;
  },
  mounted() {
    document.getElementById("app").setAttribute("style", "height:" + window.screen.height + "px");
  },
  methods: {
    loginUserVerify: function () {
      const data = { SHOW_ID: this.SHOW_ID, EMAIL: this.email, PASSWORD: this.password, ROLE: this.ROLE };
      console.log(data);
      this.$VerifyAPI
        .verifyUserInfo(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          console.log(resultObj);
          if (resultObj.statusCode === 200) {
            this.TOKEN = resultObj.body.TOKEN;
            this.BOOTH_ID = resultObj.body.BOOTH_ID;
            this.START_DATE = resultObj.body.START_DATE;
            this.END_DATE = resultObj.body.END_DATE;
            this.SHOW_LOCAL_NAME = resultObj.body.SHOW_LOCAL_NAME;

            this.redirect();
          } else if(resultObj.statusCode === 204) {
            this.$alert.warningAlert(resultObj.message);
          } else {
              this.$alert.warningAlert("Login Error!!");
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    redirect: function () {
      this.$router.push({
        name: "ShowInformation",
        params: {
          showId: this.SHOW_ID,
          boothId: this.BOOTH_ID,
          token: this.TOKEN,
          start_date: this.START_DATE,
          end_date: this.END_DATE,
          show_local_name: this.SHOW_LOCAL_NAME,
          role: this.ROLE,
        },
      });
    },
    btnExhActive: function() {
      this.isExhActive = true;
      this.isOrgActive = false;
      this.ROLE = "Exhibitors";
    },
    btnOrgActive: function() {
      this.isExhActive = false;
      this.isOrgActive = true;
      this.ROLE = "Organizer";
    },
  },
  };
</script>

<style scoped src="../../public/css/firm.reset.css" />
<style scoped src="../../public/css/firm.system.css" />

